import { fromSchema } from "collections";
import { object } from "yup";
import { audio } from "./audioSchema";
import { general } from "./generalSchema";
import { call_control } from "./callControlSchema";
import { video } from "./videoSchema";
import { wireless } from "./wirelessSchema";
import { software_update } from "./softwareUpdateSchema";
import { BasicDesktopDeviceSettings } from "./types";

export const desktopDeviceSettingsSchema = object<BasicDesktopDeviceSettings>({
  com: object({
    poly: object({
      audio,
      call_control,
      general,
      wireless,
      video,
      software_update
    })
  })
});

/**
 * Normally, just get this from the form, but the form is massive and broken up,
 * we will just export the constant directly.
 */
export const desktopDeviceSettingsSchemaFields = fromSchema(
  desktopDeviceSettingsSchema
);
